module.exports = __webpack_public_path__ + "static/media/datcord.cf708fe1.png";